import { DayInfo } from "../types/daysInMonth";

const formatLocalDate = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const generateDaysInMonth = (
  year: number,
  month: number,
  selectedOriginDates: string[] = [],
  selectedDestinationDates: string[] = [],
): DayInfo[] => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const lastDayOfMonth = new Date(year, month, daysInMonth).getDay();

  const previousMonthDays = Array.from({ length: firstDayOfMonth }, (_, i) => {
    const date = new Date(year, month, -(firstDayOfMonth - i - 1));
    const formattedDate = formatLocalDate(date);
    return {
      day: date.getDate(),
      isCurrentMonth: false,
      isSelectedOrigin: selectedOriginDates.includes(formattedDate),
      isSelectedDestination: selectedDestinationDates.includes(formattedDate),
      date: formattedDate,
    };
  });

  const currentMonthDays = Array.from({ length: daysInMonth }, (_, i) => {
    const date = new Date(year, month, i + 1);
    const formattedDate = formatLocalDate(date);
    return {
      day: i + 1,
      isCurrentMonth: true,
      isSelectedOrigin: selectedOriginDates.includes(formattedDate),
      isSelectedDestination: selectedDestinationDates.includes(formattedDate),
      date: formattedDate,
    };
  });

  const nextMonthDays = Array.from({ length: 6 - lastDayOfMonth }, (_, i) => {
    const date = new Date(year, month + 1, i + 1);
    const formattedDate = formatLocalDate(date);
    return {
      day: date.getDate(),
      isCurrentMonth: false,
      isSelectedOrigin: selectedOriginDates.includes(formattedDate),
      isSelectedDestination: selectedDestinationDates.includes(formattedDate),
      date: formattedDate,
    };
  });

  return [...previousMonthDays, ...currentMonthDays, ...nextMonthDays];
};
